export const version = "logger/5.0.0-beta.136";
